import { IJsonQueryRangeValue } from '@cian/api-models/common/json_query';
import { OutsideClick } from '@cian/outside-click-component';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import * as R from 'ramda';

import { getLandAreaLabel } from '../../utils/landArea';
import { NumberInput } from '../NumberInput';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterLandArea.css';

export interface IFilterAreaProps {
  value: IJsonQueryRangeValue;
  setMin(value: number | undefined): void;
  setMax(value: number | undefined): void;
}

export interface IFilterAreaState {
  active: boolean;
  min: number | undefined;
  max: number | undefined;
}

export class FilterLandArea extends React.Component<IFilterAreaProps, IFilterAreaState> {
  public constructor(props: IFilterAreaProps) {
    super(props);

    this.state = {
      active: false,
      min: props.value.gte,
      max: props.value.lte,
    };
  }

  public componentDidUpdate(prevProps: IFilterAreaProps) {
    if (!R.equals(prevProps, this.props)
      && (this.props.value.gte !== this.state.min || this.props.value.lte !== this.state.max)
    ) {
      this.setState({
        min: this.props.value.gte,
        max: this.props.value.lte,
      });
    }
  }

  public render() {
    const { active, min, max } = this.state;

    const areaLabel = getLandAreaLabel(min, max);

    return (
      <OutsideClick
        rootElement={<div {...mergeStyles(stylesCommon['container'], styles['container'])} data-mark="FilterArea" />}
        onOutsideClick={this.handleOutsideClick}
      >
        <button {...mergeStyles(
            stylesCommon['button'],
            active && stylesCommon['button--active'],
            !areaLabel && stylesCommon['button--empty'],
          )}
          title={areaLabel || undefined}
          onClick={this.handleButtonClick}
        >
          {areaLabel || 'Площадь'}
        </button>
        {active && <div className={styles['dropdown']}>
          <NumberInput
            className={styles['input']}
            placeholder="от"
            suffix="сот."
            integerLimit={5}
            value={min}
            onValueChange={this.handleMinValueChange}
            onBlur={this.handleMinBlur}
          />
          <NumberInput
            className={styles['input']}
            placeholder="до"
            suffix="сот."
            integerLimit={5}
            value={max}
            onValueChange={this.handleMaxValueChange}
            onBlur={this.handleMaxBlur}
          />
        </div>}
      </OutsideClick>
    );
  }

  private handleButtonClick = () => {
    this.setState((state) => ({
      active: !state.active,
    }));
  }

  private handleOutsideClick = () => {
    this.setState({
      active: false,
    });
  }

  private handleMinValueChange = (value: number | undefined) => {
    this.setState({
      min: value,
    });
  }

  private handleMaxValueChange = (value: number | undefined) => {
    this.setState({
      max: value,
    });
  }

  private handleMinBlur = () => {
    if (this.props.value.gte !== this.state.min) {
      this.props.setMin(this.state.min);
    }
  }

  private handleMaxBlur = () => {
    if (this.props.value.lte !== this.state.max) {
      this.props.setMax(this.state.max);
    }
  }
}
